module.exports = __webpack_public_path__ + "img/Company-Alignment.38eedc98.png";